import React from 'react';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Loading from '../../../Common/Loading';
import styles from './index.module.scss';

class List extends React.Component {
    static defaultProps = {
        className: '',
        data: [],
        loading: false,
        columns: 4,
        getContent: (item) => {}
    };

    static propTypes = {
        className: PropTypes.string, // list最外层容器class名
        data: PropTypes.array, // 列表数据
        loading: PropTypes.bool, // 是否正在加载
        columns: PropTypes.number, // 一行几列
        getContent: PropTypes.func, // 获取列表内容的方法
    };

    render() {
        const {
            className,
            loading,
            columns,
            data,
            getContent
        } = this.props;

        return (
            <React.Fragment>
                {
                    loading ? <Loading/> :
                        (
                            data.length ?
                                <ul className={`${styles.list} ${className} clearfix`}>
                                    {
                                        data.map((item, index) =>
                                            <li key={index} style={{width: `${100 / columns}%`}}>
                                                {
                                                    typeof getContent === 'function' && getContent(item)
                                                }
                                            </li>
                                        )
                                    }
                                </ul> :
                                <div className={styles.noDataWrap}>
                                    <div className={styles.noDataInner}>
                                        <img className={styles.noDataImg} src={require('../../../../assets/img/starList/p-list-course.png')}/>
                                        <p className={styles.noDataText}>{intl.get('LIST_EMPTY')}</p>
                                    </div>
                                </div>
                        )

                }
            </React.Fragment>
        )
    }
}
export default List;